module.exports = "/shiftTasks/components/taskInstances/taskInstancesHeaderButtons-4f82c4.html";